import { Route, Routes } from "react-router-dom";
import Home from "./component/home";
import { CV } from "./component/cv";

function App() {
  return (
    <Routes>
      <Route path='/' element={<Home />} />
      <Route path='/cv' element={<CV />} />
    </Routes>
  );
}

export default App;
